import { KnowledgeSectionService } from './../knowledge-section.service';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { SwalService } from '../../../../shared/services/swal/swal.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { interval, Subject, Subscription } from 'rxjs';
import { takeUntil, flatMap } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import encodeUrl from 'src/app/shared/sharer';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';

@Component({
    selector: 'app-articles-detail',
    templateUrl: './articles-detail.component.html',
    styleUrls: ['./articles-detail.component.scss'],
})
export class ArticlesDetailComponent implements OnInit {
    bsModalRef: BsModalRef;
    articleId: any;
    articleDetails: any;
    relatedArticleDetails: any;
    mainImg: any;
    sliderImages: any;
    imageBasePath = environment.imgUrl;
    intervalObs: Subscription;

    page = 1;
    pageSize = 1;
    unsubscribeArticles = new Subject();

    similarAppSliderConfig = {
        slidesToShow: 5,
        // slidesToScroll: 1,
        autoplay: false,
        // autoplaySpeed: 5000,
        dots: false,
        arrows: false,
        vertical: true,
        infinite: true,
        cssEase: 'ease-in-out',
    };
    slideConfigMainBanner = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        asNavFor: '.slider-nav',
        cssEase: 'ease-in-out',
    };
    slideConfigMainBannerSubImages = {
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        centerMode: true,
        focusOnSelect: true,
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true,
        cssEase: 'ease-in-out',
        lazyLoad: 'onDemand',
        arrows: false,
    };
    slideConfigMainBannerWithTwoImages = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        cssEase: 'ease-in-out',
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true,
    };
    currentUrl: string;
    sharingUrl = environment.sharingUrl;
    socialShareUrl = '';
    constructor(
        private route: ActivatedRoute,
        private service: KnowledgeSectionService,
        private toastr: ToastrService,
        private spinner: NgxSpinnerService,
        private swalService: SwalService,
        private modalService: BsModalService,
        private router: Router,
        private titleService: Title,
        private gaService: GoogleAnalyticsService
    ) {}

    ngOnInit(): void {
        this.spinner.show();
        this.route.params.subscribe((params) => {
            this.articleId = params.id;
            this.currentUrl = window.location.href;
            this.getarticleDetails();
        });
        this.callingInterval();
    }

    callingInterval() {
        this.intervalObs = interval(10 * 1000)
            .pipe(
                flatMap(() =>
                    this.service
                        .getSimilarArticlesDetails(
                            this.articleId,
                            this.page,
                            this.pageSize
                        )
                        .pipe(takeUntil(this.unsubscribeArticles))
                )
            )
            .subscribe((data) => {
                this.page += 1;
                if (data.body.page == 1) {
                    this.page = 2;
                }
                if (data.body['articles'][0]) {
                    this.relatedArticleDetails.splice(0, 1);
                    this.relatedArticleDetails.push(data.body['articles'][0]);
                }
            });
    }

    getarticleDetails(): void {
        this.service
            .getArticlesDetails(this.articleId, this.page, '5')
            .subscribe(
                (data: any) => {
                    this.spinner.hide();
                    if (data.status === 200) {
                        this.titleService.setTitle(
                            data.body.article.title + ' | Social App Hub'
                        );
                        this.gaService.eventEmitter(
                            'article',
                            'knowledge',
                            data.body.article.title
                        );
                        this.page += 1;
                        this.articleDetails = data.body.article;
                        this.socialShareUrl = this.sharingUrl +'/article/'+this.articleDetails._id;

                        // this.meta.addTags([
                        //   { name: 'twitter:description', content: this.articleDetails.description },
                        //   { name: 'twitter:title', content: this.articleDetails.title },
                        //   { name: 'twitter:image', content: this.imageBasePath + data.body.article.images[0] },
                        //   { name: "twitter:card", content:'summary_large_image' },
                        //   { name: "twitter:url", content: this.currentUrl },
                        //   { property: "og:title", content: this.articleDetails.title },
                        //   { property: "og:description", content: this.articleDetails.description },
                        //   { property: "og:image:url", content: this.imageBasePath + data.body.article.images[0] },
                        //   { property: "og:image", content: this.imageBasePath + data.body.article.images[0] },
                        //   {property:"og:type" ,content:"article"},
                        //   {property:"og:url", content:this.currentUrl}
                        // ])

                        this.relatedArticleDetails = data.body.related;
                        if (data.body.article.images.length > 0) {
                            this.mainImg = data.body.article.images[0];
                            // this.sliderImages = data.body.article.images;
                            this.multiplyScreenshots(data.body.article.images);
                        }
                    }
                },
                (err) => {
                    this.spinner.hide();
                    this.toastr.error(err.error.message, '');
                }
            );
    }

    selectImg(img: any): void {
        this.mainImg = img;
    }
    comingSoon(template: TemplateRef<any>) {
        this.bsModalRef = this.modalService.show(template, {
            animated: true,
            backdrop: 'static',
            class: 'my-modal',
        });
        // this.swalService.basicInfo('Coming Soon');
    }
    ngOnDestroy() {
        this.intervalObs.unsubscribe();
        this.unsubscribeArticles.unsubscribe();
    }

    transform(value, length) {
        if (value) {
            if (value.length > length) {
                let data: any = value.replace(/<.*?>/g, '');
                return data.substring(0, length) + '....';
            } else {
                return value;
            }
        }
    }

    multiplyScreenshots(screenshots) {
        if (screenshots.length == 3) {
            this.sliderImages = screenshots.concat(screenshots);
        } else {
            this.sliderImages = screenshots;
        }
    }
    relatedArticleDetail(data) {
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate(['/knowledge-section/article/detail', data?._id]);
    }
    searcRoute(data) {
        this.router.navigate(['/search'], {
            queryParams: { query: data },
        });
    }

    encodeSocialURI(input) {
        return encodeURIComponent(input);
    }
}
